const OPENCODE_DEFAULT_SESSION_TITLE_PREFIX = "New session - ";

/**
 * Opencode assigns a default title of "New session - <timestamp>" when a session
 * is first created. It then asynchronously generates a real title using Haiku,
 * which arrives via a subsequent `session.updated` SSE event. This function
 * identifies the placeholder title so callers can skip persisting or displaying it
 * if it's the default.
 *
 * @author Max 2026-02-26
 */
export function isDefaultOpencodeSessionTitle(title: string): boolean {
  return title.startsWith(OPENCODE_DEFAULT_SESSION_TITLE_PREFIX);
}
